"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.number.constructor");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _axios = _interopRequireDefault(require("axios"));
var _salesReport = require("@/http/interface/sfe/salesReport");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** package */
/** components */
/** services */
/** utils */
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      role: '',
      RSMList: [],
      /** page common */
      pageName: 'salesReport',
      /** enum */
      optConfig: {
        auditEMEOptions: []
      },
      /** search group */
      searchVal: {
        spName: '',
        asmName: '',
        rsmNo: ''
      },
      /** table group */
      table: {
        listLoading: false,
        list: [],
        total: 0,
        currPage: 1,
        limit: 100,
        sourceApi: null // api timer
      },
      /** others */
      loadingComponent: null,
      isLoading: false,
      lastUpdateTime: '-'
    };
  },
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.queryEnumOptions();
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.role = this.$store.getters.roles[0];
    this.queryEnumOptions();
    this.getRSMList();
    setTimeout(function () {
      _this.searchData();
    }, 300);
    console.log(this.role);
  },
  methods: {
    /**
     * 枚举
     */
    /** 格式化 枚举 */
    formatEnum: function formatEnum(key, from) {
      // console.log('formatEnum', key, this.optConfig[from])
      if ("".concat(key)) {
        console.log('-----', "".concat(key), this.optConfig[from]);
        return (0, _index.formatKeyValue)("".concat(key), this.optConfig[from]);
      }
      return '';
    },
    /** 获取计划类型 enum */queryEnumOptions: function queryEnumOptions() {
      var _this2 = this;
      var auditEME_key = 'AUDIT_EME_STATUS'; // 自身品牌
      var param = {
        configItemCodeList: [auditEME_key]
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        var data = res.data || {};
        _this2.optConfig.auditEMEOptions = data[auditEME_key] || [];
      });
    },
    /**
     * search methods
     */
    // 搜索
    searchData: function searchData() {
      this.table.currPage = 1;
      this.fetchData();
    },
    // resert saerch
    resetData: function resetData() {
      var data = this.$options.data.call(this);
      this.searchVal = data.searchVal;
      this.searchData();
    },
    /**
     * table methods
     */
    // 获取 列表
    fetchData: function fetchData() {
      var _this3 = this;
      if (this.table.sourceApi) {
        this.table.sourceApi.cancel('cancel');
      }
      this.table.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.table.currPage,
        limit: this.table.limit,
        smodel: (0, _objectSpread2.default)({}, this.searchVal)
      };
      this.table.listLoading = true;
      if (this.role === 'ASM') {
        (0, _salesReport.getSalesEmeRecordRoleList)(param, this.table.sourceApi.token).then(function (res) {
          var _ref = res.data || [],
            items = _ref.items,
            totalCount = _ref.totalCount;
          var _iterator = (0, _createForOfIteratorHelper2.default)(items),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var item = _step.value;
              item['edit'] = false;
              item['emeWeekOneQtyTemp'] = item['emeWeekOneQty'];
              item['emeWeekTwoQtyTemp'] = item['emeWeekTwoQty'];
              item['emeWeekThreeQtyTemp'] = item['emeWeekThreeQty'];
              item['emeWeekFourQtyTemp'] = item['emeWeekFourQty'];
              item['emeWeekFiveQtyTemp'] = item['emeWeekFiveQty'];
              item['emeWeekChangeQtyTemp'] = item['emeWeekChangeQty'];
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          _this3.table.list = items;
          _this3.table.total = totalCount;
          if (!_this3.table.list.isEmpty) {
            _this3.lastUpdateTime = _this3.table.list[0].lastUpdateTime;
          }
        }).catch(function (err) {
          if (_axios.default.isCancel(err)) {
            return false;
          }
        }).finally(function () {
          _this3.table.listLoading = false;
        });
      } else {
        (0, _salesReport.getSalesEmeRecordLeaderList)(param, this.table.sourceApi.token).then(function (res) {
          var _ref2 = res.data || [],
            items = _ref2.items,
            totalCount = _ref2.totalCount;
          _this3.table.list = items;
          _this3.table.total = totalCount;
          if (!_this3.table.list.isEmpty) {
            _this3.lastUpdateTime = _this3.table.list[0].lastUpdateTime;
          }
        }).catch(function (err) {
          if (_axios.default.isCancel(err)) {
            return false;
          }
        }).finally(function () {
          _this3.table.listLoading = false;
        });
      }
    },
    // 导出excel
    downloadExcel: function downloadExcel(name) {
      var _this4 = this;
      var param = (0, _objectSpread2.default)({}, this.searchVal);
      this.isLoading = true;
      (0, _salesReport.exportSalesEmeRecordLeaderList)(param).then(function (res) {
        (0, _index.downloadFileExcel)(name, res.data);
      }).finally(function () {
        _this4.isLoading = false;
      });
    },
    getRSMList: function getRSMList() {
      var _this5 = this;
      this.$api.CPPerformanceReport.getRsmList().then(function (res) {
        _this5.RSMList = res.data;
        console.log(_this5.RSMList);
      });
    },
    approveBtnClick: function approveBtnClick(item, val) {
      var _this6 = this;
      console.log(val);
      var param = {
        salesEmeRecordPk: item['salesEmeRecordPk'],
        spSapId: item['spSapId'],
        empNo: item['empNo'],
        auditStatus: val
      };
      this.isLoading = true;
      (0, _salesReport.auditSalesEmeRecord)(param, this.table.sourceApi.token).then(function (res) {
        _this6.isLoading = false;
        if (res.success) {
          _this6.$message.success(_this6.$t('salesReport.common.success'));
          _this6.fetchData();
        } else {
          _this6.$message.error(_this6.$t('salesReport.common.fail'));
        }
      }).catch(function (err) {
        _this6.isLoading = false;
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this6.isLoading = false;
        _this6.table.listLoading = false;
      });
    },
    saveBtnClick: function saveBtnClick(item) {
      var _this7 = this;
      console.log(item);
      if (!item['emeWeekOneQty'] || !item['emeWeekTwoQty'] || !item['emeWeekThreeQty'] || !item['emeWeekFourQty'] || !item['emeWeekFiveQty'] || !item['emeWeekChangeQty']) {
        this.$message.warning(this.$t('salesReport.common.warning'));
        return;
      }
      var param = {
        salesEmeRecordPk: item['salesEmeRecordPk'],
        spSapId: item['spSapId'],
        emeWeekOneQty: item['emeWeekOneQty'] || 0,
        emeWeekTwoQty: item['emeWeekTwoQty'] || 0,
        emeWeekThreeQty: item['emeWeekThreeQty'] || 0,
        emeWeekFourQty: item['emeWeekFourQty'] || 0,
        emeWeekFiveQty: item['emeWeekFiveQty'] || 0,
        emeWeekChangeQty: item['emeWeekChangeQty'] || 0
      };
      this.isLoading = true;
      (0, _salesReport.saveSalesEmeRecord)(param, this.table.sourceApi.token).then(function (res) {
        _this7.isLoading = false;
        if (res.success) {
          _this7.$message.success(_this7.$t('salesReport.common.submitSuccess'));
          _this7.fetchData();
        } else {
          _this7.$message.error(_this7.$t('salesReport.common.submitFail'));
        }
      }).catch(function (err) {
        _this7.isLoading = false;
        if (_axios.default.isCancel(err)) {
          return false;
        }
      }).finally(function () {
        _this7.isLoading = false;
        _this7.table.listLoading = false;
      });
    },
    editBtnClick: function editBtnClick(item, val) {
      item['edit'] = val;
      console.log(val);
      console.log(item);
      console.log(this.table.list);
      if (!val) {
        this.resetRowData(item);
      }
      // this.table.list = this.table.list
    },
    updateFormValue: function updateFormValue(v, key, row) {
      row[key] = v;
      this.updateEmeWeekTotalQty(row);
    },
    updateEmeWeekTotalQty: function updateEmeWeekTotalQty(row) {
      // eslint-disable-next-line no-unused-vars
      var total = 0;
      if (row['emeWeekOneQty']) {
        total += Number(row['emeWeekOneQty']);
      }
      if (row['emeWeekTwoQty']) {
        total += Number(row['emeWeekTwoQty']);
      }
      if (row['emeWeekThreeQty']) {
        total += Number(row['emeWeekThreeQty']);
      }
      if (row['emeWeekFourQty']) {
        total += Number(row['emeWeekFourQty']);
      }
      if (row['emeWeekFiveQty']) {
        total += Number(row['emeWeekFiveQty']);
      }
      row['emeWeekTotalQty'] = total;
    },
    resetRowData: function resetRowData(row) {
      // eslint-disable-next-line no-unused-vars
      var total = 0;
      row['emeWeekOneQty'] = row['emeWeekOneQtyTemp'];
      row['emeWeekTwoQty'] = row['emeWeekTwoQtyTemp'];
      row['emeWeekThreeQty'] = row['emeWeekThreeQtyTemp'];
      row['emeWeekFourQty'] = row['emeWeekFourQtyTemp'];
      row['emeWeekFiveQty'] = row['emeWeekFiveQtyTemp'];
      row['emeWeekChangeQty'] = row['emeWeekChangeQtyTemp'];
      if (row['emeWeekOneQty']) {
        total += Number(row['emeWeekOneQty']);
      }
      if (row['emeWeekTwoQty']) {
        total += Number(row['emeWeekTwoQty']);
      }
      if (row['emeWeekThreeQty']) {
        total += Number(row['emeWeekThreeQty']);
      }
      if (row['emeWeekFourQty']) {
        total += Number(row['emeWeekFourQty']);
      }
      if (row['emeWeekFiveQty']) {
        total += Number(row['emeWeekFiveQty']);
      }
      row['emeWeekTotalQty'] = total;
    },
    paddingNum: function paddingNum(inputParam) {
      return (0, _index.paddingNum)(inputParam);
    }
  }
};